// extracted by mini-css-extract-plugin
export default {"imageIcon":"style_imageIcon__olwFz"};